import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import { computed } from 'vue-demi';
import { defaultConfigProvider } from '../_util/constant';
import { replaceCamelCase } from '../_util';
export function useConfigInject(vm, compName, useBreakpoint) {
  var _compName, _compName2;
  const {
    configProvider: config
  } = vm;
  // 部分组件的 compName 可能传入的是 this.$options.name
  if ((_compName = compName) !== null && _compName !== void 0 && _startsWithInstanceProperty(_compName).call(_compName, 'Ui')) {
    // UiButton => button
    compName = compName.charAt(2).toLocaleLowerCase() + compName.slice(3);
  }
  // 中划线转驼峰
  if ((_compName2 = compName) !== null && _compName2 !== void 0 && _includesInstanceProperty(_compName2).call(_compName2, '-')) {
    compName = replaceCamelCase(compName);
  }
  const size = computed(() => {
    var _ref, _vm$size, _config$compName;
    return (_ref = (_vm$size = vm.size) !== null && _vm$size !== void 0 ? _vm$size : compName && ((_config$compName = config[compName]) === null || _config$compName === void 0 ? void 0 : _config$compName.size)) !== null && _ref !== void 0 ? _ref : config === null || config === void 0 ? void 0 : config.size;
  });
  const teleport = computed(() => {
    var _ref2, _ref3, _vm$teleport, _config$compName2;
    return (_ref2 = (_ref3 = (_vm$teleport = vm.teleport) !== null && _vm$teleport !== void 0 ? _vm$teleport : compName && ((_config$compName2 = config[compName]) === null || _config$compName2 === void 0 ? void 0 : _config$compName2.teleport)) !== null && _ref3 !== void 0 ? _ref3 : config.teleport) !== null && _ref2 !== void 0 ? _ref2 : defaultConfigProvider.teleport;
  });
  const theme = computed(() => {
    var _ref4, _ref5, _vm$theme, _config$compName3;
    return (_ref4 = (_ref5 = (_vm$theme = vm.theme) !== null && _vm$theme !== void 0 ? _vm$theme : compName && ((_config$compName3 = config[compName]) === null || _config$compName3 === void 0 ? void 0 : _config$compName3.theme)) !== null && _ref5 !== void 0 ? _ref5 : config.theme) !== null && _ref4 !== void 0 ? _ref4 : defaultConfigProvider.theme;
  });
  // screenBreakpoint 不需要响应式
  let screenBreakpoint;
  if (useBreakpoint) {
    var _ref6, _vm$screenBreakpoint, _config$compName4;
    // 如果组件有全局 size 配置，并且使用了 get-screen-size.js，两个里面的 screenBreakpoint 就会冲突并出现 bug
    // 所以用 useBreakpoint 区分下，仅在 get-screen-size.js 里面导出 screenBreakpoint
    screenBreakpoint = (_ref6 = (_vm$screenBreakpoint = vm.screenBreakpoint) !== null && _vm$screenBreakpoint !== void 0 ? _vm$screenBreakpoint : compName && ((_config$compName4 = config[compName]) === null || _config$compName4 === void 0 ? void 0 : _config$compName4.screenBreakpoint)) !== null && _ref6 !== void 0 ? _ref6 : config === null || config === void 0 ? void 0 : config.screenBreakpoint;
  }
  return {
    size,
    teleport,
    screenBreakpoint,
    theme
  };
}